export default __webpack_public_path__ + "static/SergiyPashenko-55c44903a2a314219f748a61e5095dda.jpeg";